// extracted by mini-css-extract-plugin
export default {"error":"_1aES5wFS5BidxXFOTWrWad"};